import { Stack, styled } from '@mui/material';

export const StyledNumbersStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    rowGap: theme.spacing(2),
    margin: theme.spacing(0, 0, 2, 0),
  },

  div: {
    borderRightColor: theme.palette.invertedColors?.PLUS_7,
    borderRightStyle: 'solid',
    borderRightWidth: '1px',

    '&:last-child': {
      borderRight: '0px',
    },
    [theme.breakpoints.down('md')]: {
      flex: '0 0 50%',
      border: '0px',
      '&:nth-of-type(2n+1)': {
        borderRight: `1px solid ${theme.palette.invertedColors?.PLUS_7}`,
      },

      '&:last-child': {
        border: '0px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 100%',
      border: 'none',

      '&:nth-of-type(2n+1)': {
        borderRight: `none`,
      },
    },
  },
}));
